import React from 'react';
import { Container, Typography, Paper, Box, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import SecurityIcon from '@mui/icons-material/Security';

const Privacy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box sx={{ mb: 4 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link 
            component={RouterLink} 
            to="/"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <HomeIcon sx={{ mr: 0.5, fontSize: 20 }} />
            Home
          </Link>
          <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
            <SecurityIcon sx={{ mr: 0.5, fontSize: 20 }} />
            Privacy Policy
          </Typography>
        </Breadcrumbs>
      </Box>

      <Paper elevation={2} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
          Privacy Policy
        </Typography>
        
        <Typography variant="body1" paragraph sx={{ mt: 4 }}>
          Last Updated: {new Date().toLocaleDateString()}
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          1. Introduction
        </Typography>
        <Typography variant="body1" paragraph>
          At Meal Maestro, we respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          2. Information We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          We may collect several types of information from and about users of our platform, including:
        </Typography>
        <Typography component="ul" sx={{ pl: 4 }}>
          <li>Personal identifiers such as name and email address</li>
          <li>Account credentials</li>
          <li>Dietary preferences and restrictions</li>
          <li>Usage data and interactions with our platform</li>
          <li>Device and browser information</li>
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          3. How We Use Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          We use the information we collect to:
        </Typography>
        <Typography component="ul" sx={{ pl: 4 }}>
          <li>Provide, maintain, and improve our services</li>
          <li>Process and complete transactions</li>
          <li>Generate personalized meal plans and recipes</li>
          <li>Send you technical notices, updates, and support messages</li>
          <li>Respond to your comments and questions</li>
          <li>Protect the security and integrity of our platform</li>
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          4. Cookies and Tracking Technologies
        </Typography>
        <Typography variant="body1" paragraph>
          We use cookies and similar tracking technologies to track activity on our platform and hold certain information. Cookies are files with small amounts of data that may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          5. Data Sharing and Disclosure
        </Typography>
        <Typography variant="body1" paragraph>
          We may share your information in the following situations:
        </Typography>
        <Typography component="ul" sx={{ pl: 4 }}>
          <li>With service providers who perform services on our behalf</li>
          <li>To comply with legal obligations</li>
          <li>To protect and defend our rights and property</li>
          <li>With your consent or at your direction</li>
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          6. Data Security
        </Typography>
        <Typography variant="body1" paragraph>
          We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please note that no method of transmission over the Internet or electronic storage is 100% secure.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          7. Your Data Protection Rights
        </Typography>
        <Typography variant="body1" paragraph>
          Depending on your location, you may have certain rights regarding your personal information, such as:
        </Typography>
        <Typography component="ul" sx={{ pl: 4 }}>
          <li>The right to access information we have about you</li>
          <li>The right to request correction of your personal information</li>
          <li>The right to request deletion of your personal information</li>
          <li>The right to object to processing of your personal information</li>
          <li>The right to data portability</li>
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          8. Changes to This Privacy Policy
        </Typography>
        <Typography variant="body1" paragraph>
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          9. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about this Privacy Policy, please contact us at privacy@mealmaestro.com.
        </Typography>
      </Paper>
    </Container>
  );
};

export default Privacy;
